/** @name ENABLE_FEATURE_ONETRUST
 * is used to feature toggle OneTrust cookie managing provider
 * * when "false" JQuery Cookie banner {cookie-consent.init.ts} is ON;
 * * when "true" OneTrust banner is ON, JQuery banner is OFF;
 * @see cookie-consent.init.ts
 * @summary  JQuery Cookie banner was disabled with ECH-29406, then reverted again. That is why this feature toggle was introduced.
 * @todo NOTE: after successful testing OneTrust, junk code left behind after JQuery banner should be cleaned with ECH-29443
 * */
export const ENABLE_FEATURE_ONETRUST = true;
